import billingModule from '../../billing.module';
import template from './billingModalRequestPlan.component.html';
import style from './billingModalRequestPlan.component.css';

export default billingModule.component('billingModalRequestPlan', {
    template,
    style,
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: '<'
    },
    controller(configProvider) {
        var vm = this;

        vm.$onInit = () => {
            configProvider.getConfigurations().then(data => {
                if (data && data.appspaceURLPricing) {
                    vm.urlPricing = data.appspaceURLPricing;
                }
            });
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-modal-request-plan/billingModalRequestPlan.component.js